export const PULSEPOINT_ADMIN_AGENCY: string = '999999'
export const FETCH_TIME_TO_WAIT: number = 2000
